import Vue from 'vue';

export function tabsFn() {
    const shoMoreContent = document.querySelectorAll('.tabs-section');
    (function () {
        if (!shoMoreContent || !shoMoreContent.length) {
            return false
        }
    })()

    let ids = [...shoMoreContent].map(el => el.id)
    if (ids && ids.length) {
        ids.forEach(el => {
            new Vue({
                el: `#${el}`,
                data() {
                    return {
                        activeTab: 0
                    }
                },
            })
        })
    }
}
tabsFn()